module.exports = __webpack_public_path__ + "static/logo-933d3976e7303e9704ff7e4772e62b0f.png";